<div class="confirm-modal-popup">
  <span class="material-icons close-icon-modal position-absolute" (click)="closeDialog()">close</span>
  <img src="assets/images/check-icon.svg" alt="check-icon" class="modal-icon">


  <div class="d-flex justify-content-center align-items-center mb-3" *ngIf="data.title">
    <ngx-stars [initialStars]="data.title" [totalstars]="_totalstar" [color]="'#51af57'"
      size="24px" [readonly]="true"></ngx-stars>
  </div>

  <div class="modal-message">
    <p class="f-16 pb-0 mb-0 text-grey-light" [innerHTML]="this.data.description"></p>
  </div>

  <div class="modal-actions">
    <button (click)="closeDialog()" mat-button class="btn rounded_btn green_btn small_btn px-4 fw-400">OK</button>
  </div>
</div>
